import ToggleClass from '~utilities/toggle-class';
import Field from './field';

const ERROR_CLASS = 'form__item-length--error';
const JS_LENGTH = 'js-length';
const JS_LANGUAGE = 'js-language';
let MAX_MESSAGE;

class Length extends Field {
    constructor(form, error) {
        super();
        this.error = error;
        this.form = form;
        const elements = [...form.querySelectorAll(`[${JS_LENGTH}]`)];
        this.language = this.form.getAttribute(JS_LANGUAGE);
        if(!elements.length) return;

        elements.forEach(element => {
            const field = this.getFields(element.parentElement)[0];

            this.maxLength = element.getAttribute(JS_LENGTH);
            MAX_MESSAGE = this.lengthMessage();
            this.showMessage(MAX_MESSAGE, element);

            this.bindEvents(field, element);

        });
    }
    
    validationMessage() {
        switch(this.language) {
            case 'nl':
                return `Waarde is langer dan toegestaan.`;
            case 'en':
                return `Value is longer than allowed.`;
            default:
                return `<span>Max. <b>${this.maxLength}</b> tekens</span>`;
        }
    }
    
    lengthMessage() {
        switch(this.language) {
            case 'nl':
                return `<span>Max. <b>${this.maxLength}</b> tekens</span>`;
            case 'en':
                return `<span>Max. <b>${this.maxLength}</b> characters</span>`;
            default:
                return `<span>Max. <b>${this.maxLength}</b> characters</span>`;
        }
    }

    bindEvents(field, element) {
        field.addEventListener("keyup", () => this.showLength(field, element), {passive: true});
    }

    showError(field, element) {
        const length = field.value.length;
        let hasError = length > this.maxLength ? true : false;
        this.error.errorData(hasError, `max-length`, field, element.parentElement, this.validationMessage());
    }

    showMessage(message, element) {
        element.innerHTML = message;
    }

    showLength(field, element) {
        const length = field.value.length;
        new ToggleClass(length > this.maxLength, element, ERROR_CLASS);

        !length ? this.showMessage(MAX_MESSAGE, element) : this.showMessage(`<span><b>${length}</b>/${this.maxLength} tekens</span>`, element);
        this.showError(field, element)
    }
}

export default Length;
